import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import showNotify from "./Notify";
import { translatorf } from "Languages/Utility/translatorf";

async function ShareFile(Element_id, File_name, File_text) {
  const element = document.getElementById(Element_id);
  const originalElement = element.cloneNode(true);
  element.style.letterSpacing = 'normal';
  element.style.backgroundColor = '#fff';
  element.style.border = 'none';
  element.style.boxShadow = 'none';
  const canvas = await html2canvas(element, {
    scale: 2,
    logging: true,
    useCORS: true,
    letterRendering: true,
  });
  element.replaceWith(originalElement);

  const pdf = new jsPDF("p", "mm", "a4");
  const pageWidth = 210;
  const pageHeight = 297;
  const margin = 0;

  const imgData = canvas.toDataURL("image/jpeg");
  const imgWidth = pageWidth - margin * 2;
  const imgHeight = (canvas.height * imgWidth) / canvas.width;

  let y = 0;
  if (imgHeight <= pageHeight - margin * 2) {
    pdf.addImage(imgData, "JPEG", margin, margin, imgWidth, imgHeight);
  } else {
    while (y < imgHeight) {
      pdf.addImage( imgData, "JPEG", margin, margin - y, imgWidth, imgHeight );
      y += pageHeight - margin * 2;
      if (y < imgHeight) pdf.addPage();
    }
  }

  const pdfBlob = pdf.output("blob");
  const file = new File([pdfBlob], `${File_name.replaceAll('/', '-').replaceAll('_', '-')}.pdf`, { type: "application/pdf" });

  if (navigator.canShare && navigator.canShare({ files: [file] })) {
    try {
      await navigator.share({
        files: [file],
        title: File_name,
        text: File_text,
      });
      showNotify({
        text: translatorf('share_success'),
        customClass: "question success",
        showAction: true,
        actionText: translatorf('fileDownload'),
        onActionClick: () => {
          pdf.save(`${File_name}.pdf`);
        }
      });
    } catch (error) {
      showNotify({
        text: translatorf('share_error'),
        customClass: "question warning",
        showAction: true,
        actionText: translatorf('fileDownload'),
        onActionClick: () => {
          pdf.save(`${File_name}.pdf`);
        }
      });
    }
  } else {
    showNotify({
      text: translatorf('share_device_notCompatible'),
      customClass: "question",
      showAction: true,
      actionText: translatorf('fileDownload'),
      onActionClick: () => {
        pdf.save(`${File_name}.pdf`);
      }
    });
  }
  return;
}

export default ShareFile;